import styled from 'styled-components';
import Video from '../../utils/Video/Video';

export const ReelVideoPlayerRoot = styled.div`
  position: relative;
  height: 100%;
  aspect-ratio: unset;
  outline: none;
  cursor: pointer;
`;

export const ReelVideoSurface = styled(Video)`
  height: 100%;
  aspect-ratio: unset;

  img,
  video {
    object-fit: cover;
    filter: saturate(0.95);
    transform: scale(1.02);
  }
`;

export const PlaybackIconFlash = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6.4rem;
  height: 6.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  z-index: 3;
  pointer-events: none;
  animation: fadeOut 0.8s ease forwards;

  svg {
    width: 2.8rem;
    height: 2.8rem;
  }
`;
